/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'cancel': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M1004.032 907.64L608.427 512.034l395.605-395.673C1016.934 103.458 1024 86.324 1024 68.062c0-18.159-7.1-35.26-19.934-48.06A67.584 67.584 0 00955.938 0c-18.295 0-35.43 7.1-48.298 19.968L512 415.574 116.36 19.968A67.72 67.72 0 0068.166 0C49.972 0 32.87 7.1 19.968 19.968A67.55 67.55 0 000 68.096c0 18.228 7.066 35.362 19.968 48.265l395.674 395.673L19.968 907.605A67.72 67.72 0 000 955.835c0 18.194 7.1 35.329 19.968 48.197C32.871 1016.9 49.972 1024 68.165 1024s35.328-7.1 48.196-19.968l395.673-395.605 395.606 395.605C920.508 1016.9 937.677 1024 955.87 1024c18.227 0 35.294-7.1 48.128-19.934a68.267 68.267 0 000-96.426z"/>'
  }
})
